import Vue from 'vue';
import _ from 'lodash';
import {
    GET_CARS_REQUEST,
    GET_CARS_SUCCESS,
    GET_CARS_FAILURE,
    UPDATE_CARS_PARAMS,
    RESET_CARS_STATE,
    RESOLVE_CARS_PARAMS
} from '../mutationTypes';

const state = {
    loading: false,
    page: 1,
    pageSize: 10,
    carNo: '',
    mobile:'',
    listData: [],
    pageCount: 1,
    reqParams: {},
};

const mutations = {
    // 请求开始
    [GET_CARS_REQUEST](state) {
        state.loading = true;
    },
    // 请求成功
    [GET_CARS_SUCCESS](state, res) {
        state.loading = false;
        state.pageCount = res.page_count;
        state.listData = res.car_list;
    },
    // 请求失败
    [GET_CARS_FAILURE](state) {
        state.loading = false;
        state.pageCount = 1;
        state.listData = [];
    },
    // 更新请求参数
    [UPDATE_CARS_PARAMS](state, params) {
        const {
            page, carNo, mobile
        } = params;
        if (carNo || carNo === '') state.carNo = carNo;
        if (mobile || mobile === '') state.mobile = mobile;

        if (page) {
            state.page = page;
            state.reqParams.page = page; // 分页要进行请求
        }
    },
    // 重置列表数据
    [RESET_CARS_STATE](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            page: 1,
            pageSize: 10,
            carNo: '',
            listData: [],
            pageCount: 1,
            reqParams: {},
        }));
    },
    [RESOLVE_CARS_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
};

export const actions = {
    async getCarsCarList({ commit }) {
        commit(GET_CARS_REQUEST);

        const res = await Vue.$ajax.get('carList', state.reqParams);

        if (!res.errorType) {
            commit(GET_CARS_SUCCESS, res);
        } else {
            commit(GET_CARS_FAILURE);
        }
    },
    resolveCarsCarListParams({ commit }) {
        const params = _.pick(state, ['page', 'mobile']);
        params.car_no = state.carNo;
        params.page_size = state.pageSize;
        commit(RESOLVE_CARS_PARAMS, params);
    },
    resetCarsCarList({ commit }) {
        commit(RESET_CARS_STATE);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/cars.js